module.exports = __webpack_public_path__ + "img/sec1mob.28d625e6.png";